"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var helpers = {
  getWithKeyChain: function getWithKeyChain(object, keyChain) {
    // keyChain = [keyName1, keyName2, {key3: keyName3, filterField: 'code', filterValue: 'codeValue'}]
    var reducer = function reducer(acc, cur) {
      if (typeof cur == 'string' || typeof cur == 'number') {
        return acc && acc[cur] !== 'undefined' ? acc[cur] : undefined;
      } else if (_typeof(cur) == 'object') {
        if (typeof cur.filterField != 'array') {
          cur.filterField = [cur.filterField];
        }

        return acc.filter(function (item) {
          return helpers.getWithKeyChain(item, cur.filterField) == cur.filterValue;
        }).pop();
      }
    };

    return keyChain.reduce(reducer, object); // if we don't return here we can add a edited or created or deleted tag here...
  },
  setByKeyChain: function setByKeyChain(object, payl) {
    // payl={keyChain:['key1','key2','key3'], data: dataValue}
    var subObj = object;

    var keyChain = _toConsumableArray(payl.keyChain);

    var finalObjKey = keyChain.pop();

    if (keyChain) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = keyChain[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;
          subObj = subObj[key];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    subObj[finalObjKey] = payl.data; // As using with vuex we need to deep clone the whole object for vuex
    // to notice the update.

    var newData = JSON.parse(JSON.stringify(object));
    return newData; // if we don't return here we can add a edited or created or deleted tag here...
  },
  deleteByKeyChain: function deleteByKeyChain(object, keyChain) {
    //keyChain = ['key1', 'key2', ...]
    var subObj = object;
    var finalObjKey = keyChain.pop();

    if (keyChain) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = keyChain[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var key = _step2.value;
          subObj = subObj[key];
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }

    subObj.splice(finalObjKey, 1); // As using with vuex we need to deep clone the whole object for vuex
    // to notice the update.

    var newData = JSON.parse(JSON.stringify(object));
    return newData; // if we don't return here we can add a edited or created or deleted tag here...
  },
  _mapPropToMethod: function _mapPropToMethod(value, type) {
    var mapProp = {
      offices: 'Office',
      contacts: 'Contact',
      provider_capital_types: 'CapitalType',
      provider_currencies: 'Currency',
      provider_countries: 'Country',
      provider_descriptions: 'Description',
      provider_languages: 'Language',
      provider_provider_types: 'ProviderType',
      provider_sectors: 'Sector',
      provider_social_medias: 'SocialMedia',
      provider_stats: 'Stat',
      relationships: 'Relationship'
    };
    return "".concat(type).concat(mapProp[value]);
  },
  _formatForAPI: function _formatForAPI(objName, obj, type) {
    return {
      method: this._mapPropToMethod(objName, type),
      payl: obj,
      property: objName,
      action: type
    };
  },
  //
  // Provider and EditedProvider differences methods
  //
  getDifferences: function getDifferences(provider, editedProvider) {
    var allChanges = [];

    var providerBaseChanges = this._getProvBaseObjDiff(provider, editedProvider);

    if (providerBaseChanges) {
      // find any changes to the base provider object
      allChanges = [providerBaseChanges];
    }

    var self = this;

    for (var property in provider) {
      // find any changes to the provider subobjects such as provider_countries
      if (Array.isArray(provider[property])) {
        allChanges = [].concat(_toConsumableArray(allChanges), _toConsumableArray(self._getListDiff(provider[property], editedProvider[property], property)));
      }
    }

    return allChanges;
  },
  _compareProvPropObj: function _compareProvPropObj(edited, original) {
    var checkNotEqual = false;
    var self = this;

    for (var key in edited) {
      if (!self._compareObj(edited[key], original[key])) {
        checkNotEqual = true;
      }
    }

    return checkNotEqual;
  },
  _getProvBaseObjDiff: function _getProvBaseObjDiff(original, edited) {
    var baseProvider = {};
    var methodObj = {};
    var type = 'create';

    if (edited.hasOwnProperty('id')) {
      type = 'edit';
    }

    for (var key in edited) {
      if (!(edited[key] instanceof Object || original[key] instanceof Object)) {
        if (edited[key] != original[key]) {
          baseProvider = {
            name: edited.name,
            description: edited.description,
            url: edited.url,
            year_founded: edited.year_founded,
            logo: edited.logo,
            cover_photo: edited.cover_photo,
            phone_number: edited.phone_number,
            email: edited.email
          };

          if (type == 'edit') {
            baseProvider.id = edited.id;
          }

          methodObj.method = type;
          methodObj.payl = baseProvider;
          return methodObj;
        }
      }
    }

    return undefined;
  },
  _getListDiff: function _getListDiff(list, editedList, propertyType) {
    var _this = this;

    var changes = [];
    var self = this;
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = editedList[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var editedItem = _step3.value;

        if (!editedItem.hasOwnProperty('id')) {
          changes = [].concat(_toConsumableArray(changes), [self._formatForAPI(propertyType, editedItem, 'add')]);
        } else {
          var original = list.find(function (item) {
            return editedItem.id == item.id;
          });

          if (propertyType == 'relationships') {
            if (this._compareRelationshipObj(editedItem, original)) {
              changes = [].concat(_toConsumableArray(changes), [self._formatForAPI(propertyType, editedItem, 'edit')]);
            }
          } else {
            if (this._compareProvPropObj(editedItem, original)) {
              changes = [].concat(_toConsumableArray(changes), [self._formatForAPI(propertyType, editedItem, 'edit')]);
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
          _iterator3["return"]();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    var itemsToDelete = list.filter(function (item) {
      return !editedList.find(function (editedItem) {
        return editedItem.id == item.id;
      });
    });
    itemsToDelete.forEach(function (item) {
      changes = [].concat(_toConsumableArray(changes), [_this._formatForAPI(propertyType, item, 'remove')]);
    });
    return changes;
  },
  _createEmpty: function _createEmpty(objectName, id) {
    var obj;

    switch (objectName) {
      case 'provider':
        obj = this._createEmptyProvider();
        break;

      case 'contacts':
        obj = this._createEmptyContact();
        break;

      case 'offices':
        obj = this._createEmptyOffice();
        break;

      case 'provider_stats':
        obj = this._createEmptyStat();
        break;

      case 'provider_descriptions':
        obj = this._createEmptyDescription();
        break;

      case 'provider_capital_types':
        obj = this._createEmptyCapitalTypes();
        break;

      case 'provider_currencies':
        obj = this._createEmptyCurrency();
        break;

      case 'provider_countries':
        obj = this._createEmptyCountry();
        break;

      case 'provider_languages':
        obj = this._createEmptyLanguage();
        break;

      case 'provider_provider_types':
        obj = this._createEmptyProviderType();
        break;

      case 'provider_sectors':
        obj = this._createEmptySector();
        break;

      case 'provider_social_medias':
        obj = this._createEmptySocialMedia();
        break;

      case 'relationships':
        if (id) {
          obj = this._createEmptyDeal(id);
        }

        break;
    }

    if (id) obj.object_id = id;
    return obj;
  },
  _createEmptyProvider: function _createEmptyProvider() {
    return {
      id: undefined,
      name: undefined,
      description: undefined,
      url: undefined,
      year_founded: undefined,
      logo: undefined,
      cover_photo: undefined,
      phone_number: undefined,
      email: undefined,
      offices: [],
      contacts: [],
      provider_capital_types: [],
      provider_currencies: [],
      provider_countries: [],
      provider_descriptions: [],
      provider_languages: [],
      provider_provider_types: [],
      provider_sectors: [],
      provider_social_medias: [],
      provider_stats: [],
      relationships: []
    };
  },
  _createEmptyContact: function _createEmptyContact() {
    return {
      name: undefined,
      title: undefined,
      email: undefined,
      phone_number: undefined
    };
  },
  _createEmptyOffice: function _createEmptyOffice() {
    return {
      address_line_1: undefined,
      address_line_2: undefined,
      address_line_3: undefined,
      city: undefined,
      zip_code: undefined,
      coordinates: undefined,
      phone_number: undefined,
      email: undefined,
      country: {
        name: undefined
      }
    };
  },
  _createEmptyStat: function _createEmptyStat() {
    return {
      stat: {
        name: undefined
      },
      value: undefined
    };
  },
  _createEmptyDescription: function _createEmptyDescription() {
    return {
      description: {
        name: undefined
      },
      value: undefined
    };
  },
  _createEmptyCapitalTypes: function _createEmptyCapitalTypes() {
    return {
      capital_type: {
        name: undefined
      }
    };
  },
  _createEmptyCurrency: function _createEmptyCurrency() {
    return {
      currency: {
        name: undefined
      }
    };
  },
  _createEmptyCountry: function _createEmptyCountry() {
    return {
      country: {
        name: undefined
      },
      facebook_likes: undefined,
      relevancy: 1
    };
  },
  _createEmptyLanguage: function _createEmptyLanguage() {
    return {
      language: {
        name: undefined
      }
    };
  },
  _createEmptyProviderType: function _createEmptyProviderType() {
    return {
      provider_type: {
        name: undefined
      }
    };
  },
  _createEmptySector: function _createEmptySector() {
    return {
      sector: {
        name: undefined
      },
      relevancy: 1
    };
  },
  _createEmptySocialMedia: function _createEmptySocialMedia() {
    return {
      social_media: {
        name: undefined
      }
    };
  },
  _createEmptyDeal: function _createEmptyDeal(id) {
    return {
      object_ids: [id],
      jdoc: {
        amount: undefined,
        year: undefined,
        source: undefined,
        investors: [id],
        investees: []
      }
    };
  },
  _compareObj: function _compareObj(obj_1, obj_2) {
    if (!(obj_1 instanceof Object && obj_2 instanceof Object)) {
      return obj_1 == obj_2;
    } else {
      return true;
    }

    return false;
  },
  _compareRelationshipObj: function _compareRelationshipObj(obj_1, obj_2) {
    var object_ids = JSON.stringify(obj_1.object_ids) == JSON.stringify(obj_2.object_ids);
    var investees = JSON.stringify(obj_1.jdoc.investees) == JSON.stringify(obj_2.jdoc.investees);
    var investors = JSON.stringify(obj_1.jdoc.investors) == JSON.stringify(obj_2.jdoc.investors);
    var amount = obj_1.jdoc.amount == obj_2.jdoc.amount;
    var year = obj_1.jdoc.year == obj_2.jdoc.year;
    return !(object_ids && investees && investors && amount && year);
  }
};
var _default = helpers; // module.exports = helpers

exports["default"] = _default;


// WEBPACK FOOTER //
// ../capital-finder-vuex/lib/js/helper.js